<template>
  <div class="sh_order" id="sh_order">
    <div class="sh-cart__ftotal">
      Всего: {{ total }} дженкоинов
    </div>
    <div v-if="allowBuyByAccess">
      <div class="sh_order__button" v-if="allowBuyByPrice">
        <button class="uk-button uk-button-primary" v-if="!make_order" @click="make_order = true">Оформить заказ</button>
        <div class="sh_order__order sho" v-if="make_order">
          <h3>Оформление заказа</h3>
          <div class="sho__title"></div>
          <div class="sho__intro">Внимательно заполните все поля для оформления заказа.<br>С вашего счета спишется {{ total }} дженкоинов
          </div>
          <div class="sho__form">
            <input type="text" v-model="order_data.index" class="uk-input" placeholder="Индекс">
            <input type="text" v-model="order_data.city" class="uk-input" placeholder="Город">
            <input type="text" v-model="order_data.address" class="uk-input" placeholder="Адрес доставки">
            <input type="text" v-model="order_data.name" class="uk-input" placeholder="Контактное лицо">
            <input type="text" v-model="order_data.phone" class="uk-input" placeholder="Телефон">
            <button class="uk-button uk-button-primary" @click="sendOrder">Отправить заказ</button>
          </div>
          <div class="sho__outro">Доставка по России - бесплатно. Доставка в другие страны оплачивается получателем.</div>
        </div>
      </div>
      <div v-else>
        Чтобы сделать покупку тебе не хватает
        <strong>{{ total - user.coin_balance }}</strong> дженкоинов! Накопи их и сможешь совершить эту покупку!
      </div>
    </div>
    <div v-else>Чтобы сделать покупку, сумма заказа должна быть не менее 20 коинов.</div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "order",
  inject: ['http'],
  data() {
    return {
      make_order: false,
      order_data: {
        'index': '',
        'city': '',
        'address': '',
        'name': '',
        'phone': ''
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    allowBuyByPrice() {
      let balance = this.user.coin_balance;
      if (this.total <= balance) {
        return true;
      }
      return false;
    },
    allowBuyByAccess() {
      return this.total >= 20 ? true : false
    },
    total() {
      if (this.items) {
        return _.reduce(this.items, function (sum, current) {
          return sum + (current.qnt * current.price);
        }, 0);
      }

      return 0;
    },
  },
  props: {
    items: '',
  },
  methods: {
    checkEmpty(obj) {
      return _.filter(obj, function (i) {
        return i == '';
      });
    },
    sendOrder() {
      if (this.checkEmpty(this.order_data).length > 0) {
        swal('Заполните все необходимые поля', '', 'warning');
      } else {
        let data = {
          'user_id': this.user.id,
          'total': this.total,
          'order_data': this.order_data,
          'cart': this.items
        }
        this.http.post('onSendShopOrder', data).then(res => {
          this.$store.commit('updateUserParam', {
            'param': 'property',
            'value': res.data.property
          });
          this.$store.commit('updateUserParam', {
            'param': 'coin_balance',
            'value': res.data.coin_balance
          });
          this.make_order = false;
          swal('Заказ отправлен', '', 'success');
        })
        .catch(e => swal('Что-то пошло не так', '' + e, 'error'))        
      }
    }
  }
}
</script>